import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ac4374e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "speech-api"
}
const _hoisted_2 = {
  key: 0,
  class: "article-speech"
}
const _hoisted_3 = { class: "speech-action-play-pause-btn" }
const _hoisted_4 = { class: "speech-action-play-pause-btn" }
const _hoisted_5 = { class: "speech-action-play-cancel-btn" }
const _hoisted_6 = { class: "speech-action-play-cancel-btn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "/static/image/speech_api/stop_off.svg",
  width: "32",
  height: "32"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-speed",
  src: "/static/image/speech_api/speed.svg"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "playback-speed-arrow-down",
  src: "/static/image/speech_api/arrow_down.svg"
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "playback-speed-controller"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "playback-speed-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mr08",
    src: "/static/image/speech_api/speed.svg",
    width: "14"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "再生速度")
], -1))
const _hoisted_13 = { class: "playback-speed-select" }
const _hoisted_14 = { class: "playback-speed-select-inner" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0.5 x", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0.75 x", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1 x", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1.25 x", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1.5 x", -1))
const _hoisted_20 = { class: "speech-api-button" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip-background-color-black" }, "プレスリリース読み上げ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isSpeechSupported)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isShowArticleSpeechController)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "icon",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playSpeech && _ctx.playSpeech(...args))),
                  src: "/static/image/speech_api/play.svg",
                  width: "32",
                  height: "32"
                })
              ], 512), [
                [_vShow, !_ctx.isSpeaking || _ctx.isPaused]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "icon",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pauseSpeech && _ctx.pauseSpeech(...args))),
                  src: "/static/image/speech_api/pause.svg",
                  width: "32",
                  height: "32"
                })
              ], 512), [
                [_vShow, _ctx.isSpeaking && !_ctx.isPaused]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: "icon",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelSpeech && _ctx.cancelSpeech(...args))),
                  src: "/static/image/speech_api/stop_on.svg",
                  width: "32",
                  height: "32"
                })
              ], 512), [
                [_vShow, _ctx.speechState.readContentLength !== 0]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
                [_vShow, _ctx.speechState.readContentLength === 0]
              ]),
              _createElementVNode("div", {
                class: "playback-speed",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePlaybackSpeedController()))
              }, [
                _hoisted_9,
                _createElementVNode("span", null, "再生速度 (" + _toDisplayString(_ctx.rate) + "x)", 1),
                _hoisted_10
              ]),
              (_ctx.isShowPlaybackSpeedController)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "0.5",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rate) = $event)),
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.rate]
                          ]),
                          _hoisted_15
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "0.75",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rate) = $event)),
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.rate]
                          ]),
                          _hoisted_16
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "1",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rate) = $event)),
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.rate]
                          ]),
                          _hoisted_17
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "1.25",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rate) = $event)),
                            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.rate]
                          ]),
                          _hoisted_18
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "1.5",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rate) = $event)),
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.rate]
                          ]),
                          _hoisted_19
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "playback-speed-cancel",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hidePlaybackSpeedController()))
                    }, "キャンセル")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: "/static/image/speech_api/reading.svg",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleArticleSpeechController())),
            width: "24",
            height: "24"
          }),
          _hoisted_21
        ])
      ]))
    : _createCommentVNode("", true)
}